import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AdminAuthProvider, useAdminAuth } from "./context/AdminAuthContext";
import HomePage from "./pages/HomePage";
import DashboardPage from "./pages/DashboardPage";
import PropertyDetailPage from "./pages/PropertyDetailPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import UsersPage from "./pages/admin/UsersPage";
import AccessCodesPage from "./pages/admin/AccessCodesPage";
import PropertiesPage from "./pages/admin/PropertiesPage";
import PropertyFormPage from "./pages/admin/PropertyFormPage";
import LeadsPage from "./pages/admin/LeadsPage";
import InquiriesPage from "./pages/admin/InquiriesPage";
import CategoriesPage from "./pages/admin/CategoriesPage";
import ActivityPage from "./pages/admin/ActivityPage";
import AdminsPage from "./pages/admin/AdminsPage";
import "./App.css";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-black" />;
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

const AdminRoute = ({ children }) => {
  const { isAdminAuthenticated, loading } = useAdminAuth();
  if (loading) return <div className="min-h-screen bg-white" />;
  return isAdminAuthenticated ? children : <Navigate to="/sp-command-center/login" replace />;
};

function App() {
  return (
    <AdminAuthProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
            <Route path="/property/:id" element={<PrivateRoute><PropertyDetailPage /></PrivateRoute>} />
            <Route path="/sp-command-center/login" element={<AdminLoginPage />} />
            <Route path="/sp-command-center" element={<AdminRoute><AdminLayout /></AdminRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="access-codes" element={<AccessCodesPage />} />
              <Route path="properties" element={<PropertiesPage />} />
              <Route path="properties/new" element={<PropertyFormPage />} />
              <Route path="properties/:id/edit" element={<PropertyFormPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="inquiries" element={<InquiriesPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="activity" element={<ActivityPage />} />
              <Route path="admins" element={<AdminsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </AdminAuthProvider>
  );
}

export default App;
